import * as PropTypes from 'prop-types'
import React from 'react'
import routes from '../../router/routes'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ContactBlock from '../ContactBlock'
import Link from '../Link'
import SocialBar from '../SocialBar'

import styles from './styles'


const decorators = [
  memoized,
]

function Footer(props) {
  const {
    niceCity,
    niceEmail,
    niceAddress,
    parisCity,
    parisEmail,
    parisAddress,
    copyright,
    certificate,
    legalNotice,
    cookies,
    locale
  } = props

  return (
    <div className="footer container">
      <div className="inner">
        <div className="blocks">
          <ContactBlock
            color={ContactBlock.colors.blue}
            city={niceCity}
            email={niceEmail}
            address={niceAddress}
          />
          <ContactBlock
            color={ContactBlock.colors.pink}
            city={parisCity}
            email={parisEmail}
            address={parisAddress}
          />
          <p className="certificate mobile">{certificate}</p>
        </div>
        <SocialBar
          className="social-bar"
        />
      </div>
      <div className="bottom">
        <p className="certificate desktop">{certificate}</p>
        <div className="links">
          <Link className="legal-link" route={routes.legalNotice.path} routeParams={{ locale }}>
            {legalNotice}
          </Link>
          <a href="javascript:tarteaucitron.userInterface.openPanel()" className="cookies-link">
            {cookies}
          </a>
          <p>{copyright}</p>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

Footer.propTypes = {
  niceCity: PropTypes.string,
  niceEmail: PropTypes.string,
  nicePhone: PropTypes.string,
  niceAddress: PropTypes.string,
  parisCity: PropTypes.string,
  parisPhone: PropTypes.string,
  parisEmail: PropTypes.string,
  parisAddress: PropTypes.string,
  copyright: PropTypes.string,
  certificate: PropTypes.string,
  legalNotice: PropTypes.string,
  cookies: PropTypes.string,
  locale: PropTypes.string
}

Footer.defaultProps = {
  niceCity: '',
  niceEmail: '',
  nicePhone: '',
  niceAddress: '',
  parisCity: '',
  parisPhone: '',
  parisEmail: '',
  parisAddress: '',
  copyright: '',
  certificate: '',
  legalNotice: '',
  cookies: '',
  locale: ''
}

Footer = chainDecorators(decorators, Footer)

export default Footer
